// =============================================================================
// state
// =============================================================================
const state = {
  loginToken: null,
  userName: '',
  menuStatus: 0,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  login_token: state => state.loginToken,
  user_name: state => state.userName,
  menu_status: state => state.menuStatus,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.loginToken = value.token;
    state.userName = value.user_name;
  },
  set_status (state, value) {
    state.menuStatus = value;
  },
  logout (state, value) {
    state.loginToken = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
